import { Navigate, useParams } from 'react-router-dom';
import { useClanArena, useIsClanMember } from '../../../hooks';
import { ArenaInfoLayout, ClanArena } from './ClanArena';
import { ClanReferralBonus, Header, NoClan } from '../../../components';
import { ROUTES } from '../../../routes';

const ClanArenaWrapper = () => {
  const { league, userInClan, parallelTickets } = useClanArena();
  const { hasJoined } = useIsClanMember();

  if (!league) return null;

  return (
    <>
      {hasJoined ? (
        <ClanArena
          league={league}
          userInClan={userInClan}
          parallelTickets={parallelTickets}
        />
      ) : (
        <>
          <Header
            goBack={{
              path: `${ROUTES.LEAGUE}/${league?.path}`,
              text: `Volver a ${league?.name}`,
            }}
            title="Arena"
          />

          <ArenaInfoLayout>
            <ClanReferralBonus />
            <NoClan />
          </ArenaInfoLayout>
        </>
      )}
    </>
  );
};

export default ClanArenaWrapper;

export const ClanArenaRedirect = () => {
  const { path } = useParams();

  if (!path) return null;

  return (
    <Navigate to={`${ROUTES.LEAGUE}/${path}${ROUTES.CLAN_ARENA}`} replace />
  );
};
